/* eslint-disable */

export const initialState = {
  level: null,           // Game level: [ 56, 78 ]
  data: null,            // Scene data
  scene: null,           // Scene state
  mutations: [],         // Scene mutations
  manifests: [],         // Collected manifests
  badges: [],            // Collected badges
  history: [],           // Used questions, statements and challenges
  isFinished: false,     // True if all badges have been collected
  isMuted: false         // Audio state
}

export default { ...initialState }
